import {Component, OnDestroy, OnInit} from '@angular/core';
import {OrbitaxExcelMemoService} from '../../orbitax-excel-memo.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogService} from '@shared/services/dialog-service';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {skip, takeUntil} from 'rxjs/operators';
import {memoTitle, showDataCells} from '../../orbitax-excel-memo.constants';
import {Subject} from 'rxjs';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { MatSelectChange } from '@angular/material/select';
import {CommandService} from '@core/services/command.service';
import {CreateEmptyMemoCommand, UpdateTaskMemoReportCommand} from '../../orbitax-excel-memo.commands';
import {QueryProvider} from '@shared/queries/query-provider';
import {select, Store} from '@ngrx/store';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {ParticleService} from '@core/services/particle.service';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommandResponse} from '@shared/commands/command-base';

@Component({
    standalone: false,
    selector: 'particle-excel-memo-template-content',
  templateUrl: './excel-memo-template-content.component.html',
  styleUrls: ['./excel-memo-template-content.component.scss']
})
export class ExcelMemoTemplateContentComponent implements OnInit, OnDestroy, IPlatformToolComponent {
  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;

  breadcrumbs: BreadcrumbModel[] = [];
  unsubscribe$ = new Subject<void>();
  private memoType: string;
  memoInfo: any;
  private id: string;
  convertedMemoInfo: any;
  date: any;
  hasValueChanged: boolean;
  hasMemoChanged: boolean;
  projectCountriesQueryKey = 'ProjectCountries';
  countryDictionary: any = {};

  constructor(private excelMemoService: OrbitaxExcelMemoService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private fuseSplashScreenService: FuseSplashScreenService,
              private commandService: CommandService,
              protected queryStore: Store<IQueryState>,
              private particleService: ParticleService) {
  }

  ngOnInit() {
  }

  onLoad() {
    this.id = this.magicLinkModel.fieldValues['MemoId'];
    QueryProvider.invokeQuery(this.queryStore, this.projectCountriesQueryKey, {});
    this.queryStore.pipe(takeUntil(this.unsubscribe$), select(getQueryResponse, this.projectCountriesQueryKey), skip(1))
      .subscribe( response => {
        if (response && response.length) {
          response = response.filter(o => !o.isGroup);
          response.forEach(o => {
            this.countryDictionary[o.name] = {
              proposedCount : o.counts.ProposedEntityCount,
              actualCount : o.counts.EntityCount,
              transactionCount: o.counts.TransactionCount
            };
          });
        }
      });
    this.activatedRoute.params.pipe(takeUntil(this.unsubscribe$)).subscribe((params: any) => {
      if (params && params.memoType && this.id) {
        this.memoType = params.memoType;
        this.fuseSplashScreenService.show();
        this.excelMemoService.getExcelMemo(this.id).subscribe(o => {
          this.fuseSplashScreenService.hide();
          this.memoInfo = o;
          /*          this.addBreadCrumb();*/
        });
      }
    });
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
    throw new Error('Method not implemented.');
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
    throw new Error('Method not implemented.');
  }

  onBeforeExecuteNextCommand(): boolean {
    throw new Error('Method not implemented.');
  }

  onBeforeExecutePreviousCommand(): boolean {
    throw new Error('Method not implemented.');
  }

/*  private addBreadCrumb() {
    this.breadcrumbs.push(<BreadcrumbModel>{
        id: 'planning',
        title: 'Planning',
        type: 'Planning',
        relativeUrl: `planning/${this.memoType}`
      });
    this.breadcrumbs.push(<BreadcrumbModel>{
      id: 'memoType',
      title: memoTitle[this.memoType],
      type: 'memoType',
      relativeUrl: `planning/${this.memoType}`
    });
    this.breadcrumbs.push(<BreadcrumbModel>{
      id: 'templateId',
      title: this.memoInfo.code,
      type: 'templateId',
      relativeUrl: `planning/${this.memoType}/${this.id}`
    });

  }*/

  /*viewMemo() {
    this.router.navigate(['view'], {relativeTo: this.activatedRoute});
  }*/

  isOnlyShowData(style: string): boolean {
    return showDataCells.includes(style);
  }

  onMemoValueChange(event: any, cell: any) {
    cell.isEdited = true;
    this.hasValueChanged = true;
    this.refreshMemo();
  }

  onDateChange(event: any, cell: any) {
    cell.value = new Date(event.value).toLocaleDateString();
    cell.isEdited = true;
    this.hasValueChanged = true;
    this.refreshMemo();
  }

  refreshMemo() {
    if (this.hasValueChanged) {
      this.hasMemoChanged = true;
      this.fuseSplashScreenService.show();
      this.excelMemoService.getExcelMemo(this.id, this.memoInfo.spreadsheet).subscribe(o => {
        this.fuseSplashScreenService.hide();
        this.memoInfo = o;
        this.hasValueChanged = false;
      });
    }

  }

  onFormValueChange(event: any, cell: any) {
    cell.isEdited = true;
    this.hasValueChanged = true;
  }

  parseDate(value: string) {
    const date = new Date(Date.parse(value));
    return date;
  }

  goTo(url: any) {
    this.router.navigateByUrl(url);
  }

  forceHide(templateName: any) {
    return (templateName && templateName === 'ThinCap');
  }

  ngOnDestroy(): void {
    if (this.hasMemoChanged) {
      const command = new UpdateTaskMemoReportCommand(this.id);
      this.commandService.executeCommand(command).pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
      });
    } else {
      this.unsubscribe$.next();
      this.unsubscribe$.complete();
    }
  }
}
